import { render, staticRenderFns } from "./PageFournisseurs.vue?vue&type=template&id=ed8130e4&scoped=true&"
import script from "./PageFournisseurs.vue?vue&type=script&lang=js&"
export * from "./PageFournisseurs.vue?vue&type=script&lang=js&"
import style1 from "./PageFournisseurs.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8130e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed8130e4')) {
      api.createRecord('ed8130e4', component.options)
    } else {
      api.reload('ed8130e4', component.options)
    }
    module.hot.accept("./PageFournisseurs.vue?vue&type=template&id=ed8130e4&scoped=true&", function () {
      api.rerender('ed8130e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Mercuriales/PageFournisseurs.vue"
export default component.exports